// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__ykaT8","w90":"styles_w90__4IOzy","w60":"styles_w60__DXZy5","w30":"styles_w30__4CgVs","w10":"styles_w10__bJJq9"};